import { render, staticRenderFns } from "./OpenConversationsList.vue?vue&type=template&id=38a45a8e"
import script from "./OpenConversationsList.vue?vue&type=script&lang=js"
export * from "./OpenConversationsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports